module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Influencers for '" + _vm._s(_vm.campaign.name) + "'")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Overall Summary")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.overall), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Posted")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.posted), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Posted Deliverables")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.postedDeliverables), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [(!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.YesNoOptions,
      "item-text": "text",
      "item-value": "value",
      "label": "Completed Form",
      "filled": "",
      "dense": "",
      "small": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.customFilter.completedForm),
      callback: function($$v) {
        _vm.$set(_vm.customFilter, "completedForm", $$v)
      },
      expression: "customFilter.completedForm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.YesNoOptions,
      "item-text": "text",
      "item-value": "value",
      "label": "Review in IMS",
      "filled": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.customFilter.imsReview),
      callback: function($$v) {
        _vm.$set(_vm.customFilter, "imsReview", $$v)
      },
      expression: "customFilter.imsReview"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    on: {
      "current-items": _vm.getDataTableFiltered
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.platform === 'tiktok') ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + item.handle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.handle))]) : _c('a', {
          attrs: {
            "href": 'https://www.instagram.com/' + item.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle))], 1)])]
      }
    }, {
      key: "item.followers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(_vm._f("thousandSeprator")(item.followers)) + "\n            ")])]
      }
    }, {
      key: "item.completedForm",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.completedFormEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'completedForm')
            }
          }
        }, [_c('span', {
          staticClass: "text-center"
        }, [_vm._v("\n                  " + _vm._s(_vm.completedFormText(item.completedForm)) + "\n                ")])]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-select', {
          staticClass: "input-field pt-3",
          attrs: {
            "items": _vm.getCompletedFormOptions,
            "item-value": "value",
            "item-text": "text",
            "label": "Completed Form",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.completedForm),
            callback: function($$v) {
              _vm.$set(item, "completedForm", $$v)
            },
            expression: "item.completedForm"
          }
        })], 1)])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(_vm.getStatusText(item.pairingStatus)) + "\n            ")])]
      }
    }, {
      key: "item.imsReview",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(item.imsReview ? 'YES' : 'NO') + "\n            ")])]
      }
    }, {
      key: "item.numberOfReviews",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(item.numberOfReviews) + "\n            ")])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticClass: "subtitle-2"
  }, [_vm._v("Total:")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm._f("thousandSeprator")(_vm.totals.followers)) + "\n              ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm.totals.completedForm) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm.totals.imsReview) + "\n              ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm._f("thousandSeprator")(_vm.totals.numberOfReviews)) + "\n              ")])])])], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fff2916"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/AOKReport/InfluencerModal.vue
// module id = 2120
// module chunks = 0